import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import _sortBy from "lodash/sortBy";
import _get from "lodash/get";
import _throttle from "lodash/throttle";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CardImage from './card-image';
import './compare-card-images.less';

var CompareCardImages =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareCardImages, _React$Component);

  var _super = _createSuper2(CompareCardImages);

  function CompareCardImages(props) {
    var _this;

    _classCallCheck(this, CompareCardImages);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refOuterContainer", function (e) {
      return _this.cardImagesOuterContainer = e;
    });

    _defineProperty(_assertThisInitialized(_this), "refInnerContainer", function (e) {
      return _this.cardImagesInnerContainer = e;
    });

    _defineProperty(_assertThisInitialized(_this), "refCardImage", function (e) {
      return _this.cardImages = e;
    });

    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (cardId) {
      _this.props.removeFromCompare(cardId, 'compare-card-image-remove');

      _this.handleScroll();
    });

    _this.state = {
      showFadeLeft: false,
      showFadeRight: false
    };
    _this.handleScroll = _throttle(_this.handleScroll.bind(_assertThisInitialized(_this)), 150, {
      leading: true,
      trailing: true
    });
    return _this;
  }

  _createClass(CompareCardImages, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('load', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
      this.cardImagesOuterContainer.addEventListener('scroll', this.handleScroll);
      this.cardImagesInnerContainer.addEventListener('scroll', this.handleScroll);
      this.cardImages.addEventListener('scroll', this.handleScroll);
      this.isMountedThrottleCheck = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('load', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
      this.cardImagesOuterContainer.removeEventListener('scroll', this.handleScroll);
      this.cardImagesInnerContainer.removeEventListener('scroll', this.handleScroll);
      this.cardImages.removeEventListener('scroll', this.handleScroll);
      this.isMountedThrottleCheck = false;
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      return classnames('card-images-container-outer', {
        'fade-left': this.state.showFadeLeft,
        'fade-right': this.state.showFadeRight
      });
    }
  }, {
    key: "handleScroll",
    // eslint-disable-line no-return-assign
    value: function handleScroll() {
      /**
       * Since we are running our event listeners behind trailing edge throttle, it's possible
       * this function is fired after the component has been removed from the dom.
       */
      if (!this.isMountedThrottleCheck) {
        return;
      }

      var element = this.cardImages;

      var scrollWidth = _get(element, 'scrollWidth', -1);

      var scrollLeft = _get(element, 'scrollLeft', -1);

      var offsetWidth = _get(element, 'offsetWidth', -1);

      var newFadeLeft = scrollLeft > 0;
      var newFadeRight = scrollLeft + offsetWidth < scrollWidth;

      if (this.state.showFadeLeft !== newFadeLeft || this.state.showFadeRight !== newFadeRight) {
        this.setState({
          showFadeLeft: newFadeLeft,
          showFadeRight: newFadeRight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var cardObjects = this.props.cardsToCompare; // Note: reverse cards array to match compare page.

      var cards = _sortBy(this.props.cardIDsToCompare.reverse().map(function (id) {
        return cardObjects[id];
      }), 'card_name');

      return React.createElement("div", {
        className: this.getClassNames(),
        ref: this.refOuterContainer
      }, React.createElement("div", {
        className: "card-images-container-inner",
        ref: this.refInnerContainer
      }, React.createElement("div", {
        className: "card-images",
        ref: this.refCardImage
      }, cards.map(function (card, idx) {
        return React.createElement(CardImage, {
          card: card,
          key: "card-".concat(idx),
          handleDelete: this.handleDelete
        });
      }, this))));
    }
  }]);

  return CompareCardImages;
}(React.Component);

_defineProperty(CompareCardImages, "propTypes", {
  cardIDsToCompare: PropTypes.arrayOf(PropTypes.number),
  cardsToCompare: PropTypes.objectOf(PropTypes.object),
  removeFromCompare: PropTypes.func.isRequired
});

_defineProperty(CompareCardImages, "defaultProps", {
  cardIDsToCompare: [],
  cardsToCompare: {}
});

export { CompareCardImages as default };
//# sourceMappingURL=compare-card-images.js.map